import React from 'react'
import { ScrollMain } from '../../style/commonStyle'
import { SnsPost } from '../snsPost/SnsPost'

export default function SnsFeed() {
  return (
    <ScrollMain>
      <SnsPost />
    </ScrollMain>
  )
}
